import React, { type FunctionComponent } from 'react'
import { DashContentBar } from 'legacy/dash-blocks/dash-content-bar/DashContentBar'
import { DateSelectRange } from 'legacy/dash-components/date-select-range/DateSelectRange'
import { OrderSourceFilter } from 'legacy/dash-components/order-source-filter/OrderSourceFilter'
import { RetailerLocationSelect } from 'legacy/dash-components/retailer-location-select/RetailerLocationSelect'
import { RetailerSelect } from 'legacy/dash-components/retailer-select/RetailerSelect'
import { OrderTypeFilter } from 'legacy/dash-components/order-type-filter/OrderTypeFilter'
import { type PerformanceMetricsBehaviour } from 'legacy/sections/analytics/components/performance-metrics/utils/performanceMetrics.hooks'

interface Props extends PerformanceMetricsBehaviour {}

export const PerformanceMetricsFilters: FunctionComponent<Props> = ({
  retailerId,
  setRetailerId,
  retailerLocationSelectValue,
  setRetailerLocationSelectValue,
  orderType,
  setOrderType,
  orderSource,
  setOrderSource,
  defaultDateRange,
  dateSelectRangeValue,
  setDateSelectRangeValue,
}) => (
  <DashContentBar
    leftComponents={[
      <RetailerSelect
        key="retailer-select"
        testId="performance-metrics-filters-retailer-select"
        value={retailerId}
        onChange={setRetailerId}
      />,

      <RetailerLocationSelect
        key="retailer-location-select"
        testId="performance-metrics-filters-retailer-location-select"
        value={retailerLocationSelectValue}
        onChange={setRetailerLocationSelectValue}
      />,

      <OrderTypeFilter
        key="order-type-filter"
        testId="performance-metrics-filters-order-type-filter"
        value={orderType}
        onChange={setOrderType}
      />,

      <OrderSourceFilter
        key="order-source-filter"
        testId="performance-metrics-filters-order-source-filter"
        value={orderSource}
        onChange={setOrderSource}
      />,

      <DateSelectRange
        key="date-select-range"
        testId="performance-metrics-filters-date-select-range"
        value={dateSelectRangeValue}
        onChange={setDateSelectRangeValue}
        defaultDateRange={defaultDateRange}
      />,
    ]}
  />
)
